window.Spritz = window.Spritz || {};
window.Spritz.cmd = window.Spritz.cmd || [];
